import React from 'react';
import { Routes, Route } from 'react-router-dom';

import DailyChart from 'pages/SetsDetails/DailiyChart';
import Timing from 'pages/SetsDetails/Timing';
import Cards from 'pages/SetsDetails/Cards';

const SetsDetails = () => {
  return (
    <>
      <Routes>
        <Route exact path=':id' element={<Cards />} />
        <Route path=':id/celeration' element={<DailyChart />} />
        <Route path=':id/timing' element={<Timing />} />
      </Routes>
    </>
  );
};

export default SetsDetails;